import { useQuery } from '@tanstack/react-query';
import Api, { withAcl } from 'hooks/Api';
import { useAdminParams } from 'utils/helpers';
import { useProvider } from 'utils/providers/Provider';
import { ApiError, Deal } from 'utils/types';
import { useTour } from '@reactour/tour';

import c from '../utils/constants';
import { composerDealForm } from '../utils/tour-steps/how-to-manage-a-deal/mockData';

export default function useGetDeal(id?: string, includes: string[] = []) {
  const { state } = useProvider();
  const { accountId, accountUserId } = useAdminParams();
  const args = state;
  const { isOpen } = useTour();

  return useQuery<Deal, ApiError>({
    queryKey: [c.PIPELINES, c.DEALS, id],
    queryFn: async () => {
      if (isOpen) {
        return composerDealForm;
      }
      const api = new Api(args);

      const data = await api.get(
        await withAcl({
          account: {
            url: `api/v1/sales/deals/${id}`,
            params: {
              include: [
                'accountUser',
                'pipeline',
                'company',
                'lead',
                'tag',
                ...includes,
              ],
            },
          },
          admin: {
            url: `api/v2/accounts/${accountId}/users/${accountUserId}/sales/deals/${id}`,
            params: {
              include: [
                'accountUser',
                'pipeline',
                'company',
                'lead',
                'tag',
                ...includes,
              ],
            },
          },
        }),
      );

      return data.data;
    },
    enabled: !!id,
  });
}
